import { render, staticRenderFns } from "./VInteractionHistoryList.vue?vue&type=template&id=47d8a72c&"
import script from "./VInteractionHistoryList.vue?vue&type=script&lang=js&"
export * from "./VInteractionHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports